import { DynamicLoad } from '@/_cactus_core/build/dynamicLoad';





import a7b6026fc0cae55a2107932fe4559160eb from "./generated-10ba4e70-b31d-416b-9468-6b4d1d266a64.json";

import a7c35abf9a36802e2f8a44591030efbfbb from "./generated-7279a402-1d4c-4cfc-9618-acdb315782bd.json";

import a35bb98caf08fb9faeda87a2e2236b640b from "./generated-4e8034f7-e000-404b-b8dd-7c42ffdf1597.json";

import ac1df8675189ac443bcd20f680ce0d696b from "./generated-24d671d5-270f-416e-922a-648483dc7934.json";

import a1ce1beb5f952466ab975873bb58f1486b from "./generated-106e4160-f4ea-409e-b98f-f42d8ce96783.json";

import af6c67403eaa6a221bd07a30ef189e846b from "./generated-7b9d18a4-fc29-493b-b64e-7b5d77617b3b.json";

import a5e20fc344be25a653b21120cb1d36690b from "./generated-78c2d4c5-226f-4f28-bcc4-0dace19c78df.json";

import a5f9fc39b9df582d5120de8c05b5039c0b from "./generated-9adeea3d-4389-4f99-94ea-80e54ddf005a.json";

import a130c82a8d256f44e26a143ee1f910c47b from "./generated-77f2e446-d04d-4cc0-b94c-c87acf23ade6.json";

import a9ab1e124b2b8c03240a1333550546d56b from "./generated-c27f49f3-e556-4c5d-a052-4abc0beae9fb.json";

import af511c5a92399ab4ae3509efe2ece8d8ab from "./generated-cd73c531-53cc-432c-b12f-33888f718b8c.json";

import a8c68b692eb2ca99858585015364945b3b from "./generated-c566f94b-be25-4424-8303-ccefd43d9287.json";

import a434dcb871256156b0a4b552c8338b8c8b from "./generated-c1281d38-17ce-4c2b-a387-8e5b15d0c487.json";

import a58e1ecf12544c3ca1f032217d5b6336cb from "./generated-0e0267ca-4512-4622-8113-e06591435e8e.json";

import a0e442b6da3992ff9186dd3f1f30e7530b from "./generated-da9f335c-1da7-41d5-91a1-380b0019a6fa.json";

import a6e17474b7fbbca7aa13bc5ba3a178a5db from "./generated-1b286e72-3446-438e-9aca-9e77b1b7a837.json";

import a8c032c36c333674da3e621b929c0bcfab from "./generated-4fe47468-0326-4b19-92eb-8bd1ddf13d3a.json";

import a7beca4baa8f17e01fa0424974921260cb from "./generated-0de31ad2-4df1-4ecd-a491-39ffa9819361.json";

import a9420039685ca0fd081f343042d0be290b from "./generated-56c25fd7-7c32-4927-9dc7-a9c5497ab2e1.json";





/* eslint-disable */

export default async function(url) {
  let storeData = false;

  async function direct(jsonResult) {
    return new Promise(async function(done,err) {
      try {
        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };
        
        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }

  async function ok(cachedJson) {
    return new Promise(async function(done,err) {
      try {
        const jsonResult = await DynamicLoad(cachedJson);

        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };

        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }
  
  try {
  
  




         if(url === "/api/appearance"){
            
                    await direct(a7b6026fc0cae55a2107932fe4559160eb);
                
        }
    


        else if(url === "/api/getlegalterm"){
            
                    await direct(a7c35abf9a36802e2f8a44591030efbfbb);
                
        }
    


        else if(url === "/api/country"){
            
                    await direct(a35bb98caf08fb9faeda87a2e2236b640b);
                
        }
    


        else if(url === "/api/crypto/all"){
            
                    await direct(ac1df8675189ac443bcd20f680ce0d696b);
                
        }
    


        else if(url === "/api/bff/features"){
            
                    await direct(a1ce1beb5f952466ab975873bb58f1486b);
                
        }
    


        else if(url === "/api/payment-providers"){
            
                    await direct(af6c67403eaa6a221bd07a30ef189e846b);
                
        }
    


        else if(url === "/api/bff/games/top-wins"){
            
                    await direct(a5e20fc344be25a653b21120cb1d36690b);
                
        }
    


        else if(url === "/api/bff/games/last-wins"){
            
                    await direct(a5f9fc39b9df582d5120de8c05b5039c0b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-da-pg&per_page=15"){
            
                    await direct(a130c82a8d256f44e26a143ee1f910c47b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=roleta&per_page=16"){
            
                    await direct(a9ab1e124b2b8c03240a1333550546d56b);
                
        }
    


        else if(url === "/api/undefined&per_page=undefined"){
            
                    await direct(af511c5a92399ab4ae3509efe2ece8d8ab);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-crash&per_page=15"){
            
                    await direct(a8c68b692eb2ca99858585015364945b3b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-de-aventura&per_page=15"){
            
                    await direct(a434dcb871256156b0a4b552c8338b8c8b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=cassino-ao-vivo&per_page=15"){
            
                    await direct(a58e1ecf12544c3ca1f032217d5b6336cb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=slots&per_page=15"){
            
                    await direct(a0e442b6da3992ff9186dd3f1f30e7530b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-novos&per_page=15"){
            
                    await direct(a6e17474b7fbbca7aa13bc5ba3a178a5db);
                
        }
    


        else if(url === "/api/casino-games/filter?per_page=1&per_page=15"){
            
                    await direct(a8c032c36c333674da3e621b929c0bcfab);
                
        }
    


        else if(url === "/api/casino-games/filter?providers[]=hacksaw&per_page=15"){
            
                    await direct(a7beca4baa8f17e01fa0424974921260cb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=blackjack&per_page=15"){
            
                    await direct(a9420039685ca0fd081f343042d0be290b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories%5B%5D=all"){
            
                    await direct(a8c032c36c333674da3e621b929c0bcfab);
                
        }
    





  } catch(ex){
    console.log('failed to get cache',ex,url);
  }

  return storeData;
};

/* eslint-enable */